import gql from 'graphql-tag';

const queries = {

  /** Get all users */
  USERS: gql`
    query users {
      users {
        id
        role
        username
        name
        email
        status
        createdAt
        updatedAt
    }
  }`,


  /** Get all towers */
  TOWERS: gql`
  query towers {
    towers {
      id
      ethId
      name
      bank
      height
      rate
      state
      isPrivate
      founder
    }
  }`,

  /** Get all players */
  PLAYERS: gql`
    query players {
      players {
        id
        publicAddress
        name
        email
        avatar
        type
        createdAt
        updatedAt
        totalVisits
      }
    }`,

  /** Get all invites */
  INVITES: gql`
    query invites {
      invites {
        id
        publicAddress
        email
        createdAt
        updatedAt
      }
    }`,

  /** Get all players */
  RECIPIENTS: gql`
    query recipients {
      recipients {
        id
        name
        email
        counter
        createdAt
        updatedAt
      }
    }`,
};

export default queries;
